// extracted by mini-css-extract-plugin
module.exports = {"AboutPage":"AboutPage_AboutPage__1Ey63","Uniswap":"AboutPage_Uniswap__2YvNt"};